// components/ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { bootstrapSession, getRole } from "../auth";

export default function ProtectedRoute({ children, role }) {
  const [ready, setReady] = React.useState(false);
  const [allowed, setAllowed] = React.useState(false);

  React.useEffect(() => {
    let active = true;

    (async () => {
      const ok = await bootstrapSession();
      if (!active) return;
      const currentRole = getRole();
      setAllowed(ok && (!role || currentRole === role));
      setReady(true);
    })();

    return () => {
      active = false;
    };
  }, [role]);

  if (!ready) return null;

  if (!allowed) {
    return <Navigate to={role ? "/consulta" : "/"} replace />;
  }

  return children;
}
